import ArchivedNdasModal from './ArchivedNdasModal.component';

export default ArchivedNdasModal;